import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MessageCreateTab from './MessageCreateTab';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import CreateButton from '../buttons/CreateButton';

function CreateMessageRow() {
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-message-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}><FontAwesomeIcon icon="plus" />&nbsp;{t('messages.create-message')}</CreateButton>
            {isCreateVisible && <MessageCreateTab hideHandler={() => setCreateVisible(false)} />}
        </div>
    );
}

export default withPrivileges([Privileges.MESSAGE_EDIT])(CreateMessageRow);
